import { Injectable, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PromotionExcludeDTO } from './promotion-exclude.model';

@Injectable({
  providedIn: 'root',
})
export class PromotionExcludeService implements OnInit {
  constructor(private http: HttpClient) {}

  ngOnInit(): void {}

  public update(playerId: number, request: PromotionExcludeDTO): Observable<void> {
    return this.http.patch<void>(`/promotions/api/back-office/v1/players/${playerId}/promotion-exclude`, request);
  }

  public get(playerId: number): Observable<PromotionExcludeDTO> {
    return this.http.get<PromotionExcludeDTO>(`/promotions/api/back-office/v1/players/${playerId}/promotion-exclude`);
  }
}
